<div id="divBoundary{{fieldName}}{{key}}" class="boundary gbl-boundary map-common-wrap">

      <mat-form-field #formFieldContainer floatLabel="always" appearance="none" class="map-label">
          <mat-label
            #labelContainer  (click)="toggleTooltip(tooltip)"
            class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
            {{componentDefinition?.label}}
          </mat-label>
          <div class="labelToolTipContainer"
               #tooltip="matTooltip"
               matTooltip="{{componentDefinition.label}}"
               [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
          </div>
          <input matInput [hidden]="true"
              [id]="componentDefinition?.name" [name]="componentDefinition?.name"
              />
      </mat-form-field>

      <div class="boundary-map-wrap">

      <div class="address-map-row boundary f-flex f-flex-row">
        <div class="ft-address-left-panel address-panel" *ngIf="!hideAddress">


          <div class="left-panel-address f-flex f-flex-row f-flex-wrap">
            <div [id]="keyName+'GeoAutoComplete'" [class]="keyName+'GeoAutoComplete'" style="width: 100%">
              <geo-auto-complete [autocompleteBox]="autoCompleteBox"
                                  [keyName]="keyName" [disabled]="disabled"
                                  (getStreetData)="onGetStreetData($event)" (removeStreetCb)="onRemoveStreetCb()"
                                  [geocodeSearchService]="geocodeSearchService"
                                  [EPSG]="mapFunc?.EPSG" [mapFunc]="mapFunc" [componentDefinition]="componentDefinition"
                                  (init)="initGeoAutoComplete($event)"
                                  [isParentReady]="isComponentReady"
                                  [template]="template"
                                  [fieldName]="fieldName"
                                  >
              </geo-auto-complete>
            </div>

            <div [id]="keyName+'StreetDataWrapper'" style="width: 100%">
              <street-data [keyName]="keyName"
                [disabled]="disabled"
                [disableAddress] = "disableAddress"
                [isParentReady]="isComponentReady"
                [template]="template"
                [fieldName]="fieldName"
                [registeredControlName]="registeredControlName"
                [parentComponent]="this"
                (evtInit)="onStreetDataComponentInit($event)"
              ></street-data>
            </div>
            

          </div>
        </div>
        <div #info id="info" class = "map-popover"
            [style.left]="mapFunc?.infoPosition.left" [style.top]="mapFunc?.infoPosition.top"
            [style.display]="mapFunc?.isPopoverOpen? 'table': 'none'"
            [style.zIndex]="toolTipZIndex" >
            <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                <div #tooltipInfo [id]="keyName+'tooltipInfo'" [style.zIndex]="toolTipZIndex"
                    [class]="mapFunc?.isToolTipScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                </div>
            </div>
        </div>
        <div #info1 id="info1" class = "map-popover"
            [style.left]="mapFunc?.infoRadioPosition?.left" [style.top]="mapFunc?.infoRadioPosition?.top"
            [style.display]="mapFunc?.isPopupRadioOpen? 'table': 'none'"
            [style.zIndex]="toolTipZIndex" >
            <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                <div #radioPopupInfo [id]="keyName+'radioPopupInfo'" [style.zIndex]="toolTipZIndex"
                [class]="isRadioPopupScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                    <div *ngFor="let post of postList" [innerHtml]="post | sanitizeHtml"></div>
                    <button type="button" class="btn" style="color:black;" (click)="selectAssetPopup()" [hidden]="disablePopupOkButton">OK</button>
                </div>
            </div>
        </div>
        <div #infoCluster id="infoCluster" class = "map-popover"
            [style.left]="mapFunc?.infoClusterPosition?.left" [style.top]="mapFunc?.infoClusterPosition?.top"
            [style.display]="isPopupClusterOpen? 'table': 'none'"
            [style.zIndex]="toolTipZIndex" >
            <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                <div #clusterPopupInfo [id]="keyName+'clusterPopupInfo'" [style.zIndex]="toolTipZIndex"
                [class]="isClusterPopupScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                    <div *ngFor="let post of clusterList" [innerHtml]="post | sanitizeHtml"></div>
                    <button type="button" class="btn" style="color:black;" [hidden]="!allowSelectAsset" (click)="closeClusterPopup(false)" >Close</button>
                    <button type="button" class="btn" style="color:black;" [hidden]="allowSelectAsset" (click)="closeClusterPopup(true)" >OK</button>
                </div>
            </div>
        </div>
        <div class="map-panel boundary ft-map-wrap" #mapView [id]="keyName+'map-view'"
              [style.height]="mapFunc?.mapHeight" style="width:100%;" >
          <div #map [id]="keyName+'map'" style="width:100%; height:100%;position: relative;">
            <!-- div info & info1 will put here after render map -->
            <div [id]="keyName+'_closeTextBox'" style="display: none; position: absolute;"></div>
          </div>
        </div>
        
      </div>

    </div>
    <div [id]="keyName+'_dimension_editor_container'" style="display: none; position: absolute; flex-direction: column;">
      <input [id]="keyName+'_dimension_editor_input'" type="number"/>
      <button [id]="keyName+'_dimension_eitor_re_calculate'">re-calculate</button>
      <button [id]="keyName+'_dimension_editor_close'">close</button>
    </div>
    
  <!-- TO DO : <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display> -->
</div>


